import { ref, onMounted } from '@vue/composition-api'
import useUserId from './useUserId'

const useRoomRequests = data => {

    const { userId } = useUserId()

    const request = ref(null)

    const chooseRequest = (arr, desc = 1) => {
        const statuses = ['pending', 'accepted', 'declined', 'cancelled', 'expired']
        const reqs = arr
            .sort((a,b) => a[a.side].update_date._seconds > b[b.side].update_date._seconds ?  desc : -desc)
            .reduce((accum, el) => {
                if(!accum[el.status]){
                    accum[el.status] = el
                }
                return accum
            }, {})
    
        for(let status of statuses) {
            if(reqs[status]){
                return reqs[status]
            }
        }
    }

    onMounted(() => {

        const requests = data.map(item => ({
            ...item,
            side: item.receiver.uid === userId ? 'receiver' : 'sender'
        }))
    
        const today = Math.floor(Date.now()/1000)
    
        let upcomingRequests = requests
            .filter(item => item[item.side].update_date._seconds > today)

        request.value = upcomingRequests.length ? chooseRequest(upcomingRequests) : chooseRequest(requests, -1)
       
    })

    return {
        request
    }
}

export default useRoomRequests